import React from 'react';
import * as PIXI from 'pixi.js';
import { isMobile, isTablet } from 'react-device-detect';
import './App.css';
import Game from './Game.js';
import { textManager } from './lib/lang/TextManager.js';
import WSConnectionProvider from './connection/ws/WSConnectionProvider';
import Loader from './Loader.jsx';
import { soundManager } from './lib/sounds/SoundManager';
import { assetList } from './lib/assets';
import { assetListMobile } from './lib/assetamobile';
import * as soundsList from './lib/sounds/sounds';
import { EVENTS } from './lib/constants';
import { ReelConfig } from './lib/globals/ReelConfigs.js';
import { ReelConfigMobile } from './lib/globals/ReelConfigsMobile.js';
import { GameConfigs } from './lib/globals/GameConfigs.js';
import serverMSG from '../src/helpers/gameHandlers/serverMsg';
import InfoPage from './info/Info.jsx';
import { getCurrencySymbol } from './controllers/helper/currencies.js';
import { logRecevied } from './socket/helpers/loger.js';
import ExternalError from './ExternalError.jsx';
import { getSocketURL } from './socket/helpers/getSocketURL.js';

let inited = false;
class App extends React.Component {
	assetsList = isMobile || isTablet ? assetListMobile : assetList;
	soundsList = soundsList;
	game = null;
	socket = null;
	ui = null;
	resizeTimeoutId = null;

	constructor(props) {
		super(props);
		// window.isMobile = window.innerWidth < window.innerHeight;
		window.isMobile = isMobile;
		window.isTablet = isTablet;
		this.WS_URL = getSocketURL();
		// ('wss://dev.orbitalgaming.io/wsbridge/v1/game/orbital.cosmoclassic');
		// this.WS_URL =
		// 	'ws://192.168.88.68:10045/wsbridge/v1/game/orbital.cosmoclassic';
		this.name = 'creepycashclassic';
		GameConfigs.ReelConfig =
			isMobile || isTablet ? ReelConfigMobile : ReelConfig;
		this.errorPage = null;
		this.state = {
			loaded: false,
			isLoadedGame: false,
			lang: null,
			logoText: false,
			animate: false,
			progress: 0,
			ws: null,
			info: false,
			configs: null,
			currency: null,
			currAbr: null,
			externalError: false
		};
	}
	componentDidMount() {
		if (inited) {
			return;
		}

		inited = true;
		window.cfg = {};
		window.CurrentSize = {};
		try {
			this.pixi = new PIXI.Application({
				width: Math.max(1, window.innerWidth),
				height: Math.max(1, window.innerHeight),
				resolution: devicePixelRatio,
				autoDensity: true,
				antialias: false,
				resizeTo: window,
				backgroundAlpha: 0,
				forceCanvas: false
			});

			if (process.env.NODE_ENV === 'development') {
				// Enable PIXI inspecting tool
				window.__PIXI_APP__ = this.pixi;
			}

			GameConfigs.Pixi = this.pixi;
			GameConfigs.App = this;
			PIXI.Assets.addBundle('assets', this.assetsList);
			PIXI.Assets.backgroundLoad(Object.keys(this.assetsList));
			PIXI.Assets.loadBundle('assets', this.progress.bind(this)).then(
				(result) => this.loaded(result),
				(error) => this.error(error)
			);
			window.sm = soundManager;
			window.sm.load(this.soundsList);

			if (window.screen) {
				window.screen.orientation.addEventListener(
					'change',
					this.resized.bind(this)
				);
			}
			window.addEventListener('resize', this.resized.bind(this));
			window.addEventListener(EVENTS.SERVER_MSG, this, false);
			window.addEventListener(EVENTS.MODAL, this, false);
			window.addEventListener(EVENTS.LANGUAGE_CHANGED, (message) => {
				this.setState({ lang: message.detail.langCode });
				textManager.refreshTextsPack(message.detail.langCode);
			});

			this.pixi.view.addEventListener('wheel', this.preventPinchZoom, {
				passive: false
			});
			this.pixi.view.addEventListener('touchmove', this.preventPinchZoom, {
				passive: false
			});
		} catch (error) {
			this.setState({ externalError: true });
			console.error('Error initializing PixiJS:', error);
		}
	}
	preventPinchZoom = (event) => {
		event.preventDefault();
	};

	handleCurrency(curr) {
		this.setState({ currency: getCurrencySymbol(curr)[0] });
		this.setState({ currAbr: curr });
	}

	handleEvent(object) {
		if (object.type === EVENTS.MODAL) {
			if (object.detail.modal === 'info') {
				setTimeout(() => {
					this.setState({ info: true });
				}, 50);
			} else {
				setTimeout(() => {
					this.setState({ info: false });
				}, 50);
			}
		}
		if (object.type === EVENTS.SERVER_MSG) {
			if (object.detail.service === 'config') {
				GameConfigs.config = object.detail.data;
				GameConfigs.currentBet = GameConfigs.settings.current_bet
					? object.detail.data.bet_steps[GameConfigs.settings.current_bet]
					: object.detail.data.bet_steps[0];
				this.setState({ configs: object.detail.data });
				GameConfigs.ReelConfig.linesConfig.lines = object.detail.data.lines;
				if (this.game === null) {
					this.game = new Game();
					this.pixi.stage.addChild(this.game);
					this.resized();

					logRecevied(object.detail);
					window.removeEventListener(EVENTS.SERVER_MSG, this, false);
				}
				setTimeout(() => {
					this.setState({ isLoadedGame: true });
				}, 300);
			} else {
				serverMSG(object.detail, this.handleCurrency.bind(this));
			}
		}
		if (object.type === 'orientationchange') {
			//todo check if 1000 helps here instead of resizedafter
			setTimeout(() => {
				this.resized();
			}, 100);
		}
	}

	resized() {
		//1920x1080
		this.resizeAfter();
		clearTimeout(this.resizeTimeoutId);
		this.resizeTimeoutId = setTimeout(() => {
			this.resizeAfter();
		}, 1000);
	}

	resizeAfter() {
		var w = window.innerWidth;
		var h = window.innerHeight;

		var sx = w / GameConfigs.APP_WIDTH;
		var sy = h / GameConfigs.APP_HEIGHT;
		var scaleFactor = Math.min(sx, sy);
		if (scaleFactor > 1) {
			scaleFactor = 1;
		}
		window.CurrentSize.w = w;
		window.CurrentSize.h = h;
		window.CurrentSize.s = scaleFactor;

		this.pixi.resize(w, h);
		if (this.game) {
			this.game.resize(w, h, scaleFactor);
		}
		if (this.errorPage) {
			this.errorPage.resize(w, h, scaleFactor);
		}
	}

	error(err) {
		console.log(err);
	}
	loaded() {
		document?.getElementById('main')?.appendChild(this.pixi.view);
		setTimeout(() => {
			window.connectionProvider = new WSConnectionProvider(this.WS_URL);
			this.resized();
		}, 500);
	}
	progress(val) {
		if (val > 0) {
			setTimeout(() => {
				const progressEl = document.getElementById('progress');
				const percentage = val * 100;

				if (progressEl) {
					progressEl.style.opacity = 1;
				}

				setTimeout(() => {
					this.setState({
						logoText: true,
						progress: percentage + '%'
					});
				}, 500);
			}, 500);
		}
	}

	render() {
		if (!this.state.lang) return null;
		return (
			<>
				{!this.state.loaded && !this.state.externalError && (
					<Loader
						logoText={this.state.logoText}
						progress={this.state.progress}
						animate={this.state.animate}
						isLoadedGame={this.state.isLoadedGame}
						onFinishedAnimation={() => {
							setTimeout(() => {
								this.setState({ animate: true }, () => {
									setTimeout(() => {
										this.setState({ loaded: true });
									}, 500);
								});
							}, 500);
						}}
					/>
				)}
				{this.state.externalError && <ExternalError />}

				<div id='main'>
					{this.state.info && (
						<InfoPage
							configs={this.state.configs}
							curr={this.state.currency}
							currAbr={this.state.currAbr}
						/>
					)}
				</div>
			</>
		);
	}
}

export default App;
